import dynamic from 'next/dynamic';

import { Modal } from '~components/Modals/Base';
import type { BannerModalProps } from '~features/newsBanner/model/types';

import { modalStyle } from './styles';

const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

export const BannerModal = ({
	open,
	locked,
	onClose,
	...props
}: BannerModalProps) => {
	return (
		<Modal className={modalStyle} open={open} locked={locked} onClose={onClose}>
			<Content open={open} locked={locked} onClose={onClose} {...props} />
		</Modal>
	);
};
